import React from "react";
import { type ListTemplateLayout } from "components/ListTemplate/types";
import { routes } from "utilities/routing/generatedRoutes";
import LinkedShowsList from "components/LinkedShows/LinkedShowsList";
import { formatTime, formatWrittenDayMonthYear } from "utilities";
import { AppointmentPhase } from "components";
import { LargeClickableTitle } from "components/ListTemplate/LargeClickableTitle";

const TrainFromTo = ({ train }: { train: server.dto.TrainForList }) => {
  const arrivalDateAndTime = train.segment.start.dateTimeLocal === train.segment.end.dateTimeLocal
    ? formatTime(train.segment.end.dateTimeLocal)
    : `${formatWrittenDayMonthYear(train.segment.end.dateTimeLocal)} ${formatTime(train.segment.end.dateTimeLocal)}`;

  return <div className="flex-2 journey-card-grid">
    <div className="departs-from">
      <div className="info-text-regular margin-bottom-large">
        {formatWrittenDayMonthYear(train.segment.start.dateTimeLocal)}
      </div>
      {train.segment.start.station && <>
        <div className="subtitle-text-regular margin-bottom-small">
          {train.segment.start.station.name}
        </div>
        <div className="text-sublabel margin-bottom-small">
          {train.segment.start.station.address.city ? `${train.segment.start.station.address.city}, ` : ""}
          {train.segment.start.station.address.countryName}
        </div>
      </>}
    </div>
    <div className="departure-time nowrap info-text-regular">
      {formatTime(train.segment.start.dateTimeLocal)}
    </div>
    <div className="arrow">
      <i className="icon-arrow-right small" />
    </div>
    <div className="arrives-at">
      <div className="info-text-regular margin-bottom-large">
        {arrivalDateAndTime}
      </div>
      {train.segment.end.station && <>
        <div className="subtitle-text-regular margin-bottom-small">
          {train.segment.end.station.name}
        </div>
        <div className="text-sublabel margin-bottom-small">
          {train.segment.end.station.address.city ? `${train.segment.end.station.address.city}, ` : ""}
          {train.segment.end.station.address.countryName}
        </div>
      </>}
    </div>
  </div>;
};

export const cardLayout = (onShowChange: () => void): ListTemplateLayout<server.dto.TrainForList> => ({
  type: "card",
  sections: {
    renderTitle: item =>
      <LargeClickableTitle
        uri={routes.train_Detail(item.trainId).absolute}
        icon={<AppointmentPhase value={item.phase} displayLabel={false} />}
        title={`${item.segment.description} : ${item.segment.title}`}
      />,
    hideTitle: () => false,
    renderBody: item => <>
      <TrainFromTo train={item} />
      <LinkedShowsList onChange={onShowChange} shows={item.segment.linkedShows} />
    </>,
    renderFooter: item => <div>
      <div className="margin-bottom-small">
        {item.artists.map((artist, index) => <React.Fragment key={artist.artistId}>
          <span>{artist.name}</span>
          {item.artists.length - 1 !== index && <span>, </span>}
        </React.Fragment>)}
      </div>
      <div>
        {item.travellers.map((traveller, index) => <React.Fragment key={traveller.contactId}>
          <span className="s1_gray">{traveller.name.fullName}</span>
          {item.travellers.length - 1 !== index && <span className="s1_gray">, </span>}
        </React.Fragment>)}
      </div>
    </div>,
    hideFooter: item => item.artists.length === 0 && item.travellers.length === 0
  }
});